<template>
<div v-if="actor">
    <div>
        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12 sm4 align-center justify-center layout>
                    <v-card flat class="mr-2">
                            <v-card-text>
                                <v-avatar size="112px" v-ripple v-if="actor.photo_url!=null" class="mb-3">
                                    <img :src="`/${actor.photo_url}`" alt="avatar" >
                                </v-avatar>
                                <v-avatar size="112px" v-ripple v-else class="grey lighten-3 mb-3">
                                    <span>avatar</span>
                                </v-avatar>
                                <h3>{{ actor.first_name }} {{ actor.last_name }}</h3>
                                <h3>ID :  {{ actor.id }}</h3>
                            </v-card-text>
                        </v-card>
                </v-flex>

                <v-flex xs12 sm8>
                    <v-card flat class="mr-2">
                        <v-card-title>Informations <br/> personnelles</v-card-title>
                        <v-card-text>
                            <table class="table show-table" style="width: 100%;">
                                <tbody>
                                    <tr>
                                        <td>Genre</td>
                                        <td>{{ actor.gender }}</td>
                                    </tr>
                                    <tr>
                                        <td>Age</td>
                                        <td>{{ actor.age }}</td>
                                    </tr>
                                    <tr>
                                        <td>Langue</td>
                                        <td>{{ actor.language }}</td>
                                    </tr>
                                    <tr>
                                        <td>Niveau d'instruction</td>
                                        <td>{{ actor.instruction_level }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
    <div>
        <v-card flat class="mt-4">
            <v-card-title>Informations professionnelles</v-card-title>
            <v-card-text>
                <table class="table show-table" style="width: 100%;">
                    <tbody>
                        <tr>
                            <td>Type d'acteur</td>
                            <td>{{ actor.type }}</td>
                        </tr>
                        <tr>
                            <td>Organisation</td>
                            <td v-if="actor.organization">{{ actor.organisation.name }}</td>
                        </tr>
                        <tr>
                            <td>Maillon</td>
                            <td v-if="actor.maillon">{{ actor.maillon.name }}</td>
                        </tr>
                        <tr>
                            <td>Chaine de valeur</td>
                            <td>{{ actor.instruction_level }}</td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
        </v-card>
    </div>
    <div>
        <v-card flat class="mt-4">
            <v-card-title>Informations de localisation</v-card-title>
            <v-card-text>
                <table class="table show-table" style="width: 100%;">
                    <tbody>
                        <tr>
                            <td>Pays</td>
                            <td v-if="actor.country">{{ actor.country.name }}</td>
                        </tr>
                        <tr>
                            <td>Département</td>
                            <td v-if="actor.department">{{ actor.department.name }}</td>
                        </tr>
                        <tr>
                            <td>Commune</td>
                            <td v-if="actor.municipality">{{ actor.municipality.name }}</td>
                        </tr>
                        <tr>
                            <td>Arrondissement</td>
                            <td v-if="actor.district">{{ actor.district.name }}</td>
                        </tr>
                        <tr>
                            <td>Ville/Village</td>
                            <td v-if="actor.town">{{ actor.town.name }}</td>
                        </tr>
                        <tr>
                            <td>Adresse physique</td>
                            <td>{{ actor.address }}</td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
        </v-card>
    </div>
    <div>
        <v-card flat class="mt-4">
            <v-card-title>Informations de contact</v-card-title>
            <v-card-text>
                <table class="table show-table" style="width: 100%;">
                    <tbody>
                        <tr>
                            <td>Contact</td>
                            <td>{{ actor.contact }}</td>
                        </tr>
                    </tbody>
                </table>
            </v-card-text>
        </v-card>
    </div>
    <div>
        <v-card flat class="mt-4">
            <v-card-title>Evenements suivis</v-card-title>
            <v-card-text>No available here</v-card-text>
        </v-card>
    </div>
</div>
</template>
<script>
export default {
    name: 'actor-show-view',
    layout: 'default',
    data () {
            return {
            }
        },
        created() {
            this.$store.dispatch('fetchPublicActor', this.$route.params.id)
        },
        computed: {
            actor (){ return this.$store.getters.actor }
        }
}
</script>
<style scoped>
.show-table td,
.show-table th{
  padding: 5px 30px;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/details.vue